import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-customer-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss'],
})
export class CustomerChartComponent implements OnChanges {

  @Input() options: any;
  @Input() size = [700,400];

  constructor() { }

  ngOnChanges() {
    if (this.options) this.options.tooltip.formatter = (params) => {
      let markup = `<div style="text-align:center"><b>${params[0].axisValueLabel}</b><br><table style="margin:auto">`;
      for (const param of params) {
        const value = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'EUR' })
          .format(param.value).replace(/€(.*)/,'$1 €');
        markup += `
          <tr>
            <td style="color:${param.color}">●</td>
            <td style="margin:0 1rem">${param.seriesName}</td>
            <td style="width:8rem;text-align:right"><b>${value}</b>
            </td>
          </tr>`
      }
      markup += '</table></div>'
      return markup;
    }
    // console.log('charts options', this.options);
  }

}
